import { render, staticRenderFns } from "./everyday_answer.vue?vue&type=template&id=f96ad24a&scoped=true&"
import script from "./everyday_answer.vue?vue&type=script&lang=js&"
export * from "./everyday_answer.vue?vue&type=script&lang=js&"
import style0 from "./everyday_answer.vue?vue&type=style&index=0&id=f96ad24a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96ad24a",
  null
  
)

export default component.exports